import {Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output} from "@angular/core";
import {IntClickOutsideService} from "../../services";

@Directive({
  selector: '[intClickOutside]',
  providers: [
    IntClickOutsideService
  ]
})
export class IntClickOutsideDirective {

  @Input() excludeElements:  HTMLElement | Array<HTMLElement> | null = []

  @Output() onClickOutSide = new EventEmitter();

  constructor(
    private readonly element: ElementRef,
    private readonly controller: IntClickOutsideService
  ) {}
  @HostListener('document:click', ['$event']) onClick(e: Event) {
    const list = Array.isArray(this.excludeElements) ? this.excludeElements : [this.excludeElements]
    const excludes = [this.element.nativeElement, ...list];
    if(this.controller.isNotExcludeElements(
      //@ts-ignore
      e.target, excludes)) {
      this.onClickOutSide.emit();
    }
  }
}
